import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const Verified: React.FC<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20">
    <path d="M17 9V12C17 12.24 16.87 18 10 18C3.13 18 3 12.24 3 12V2H19V0H1V12C1 12.08 1.1 20 10 20C18.9 20 19 12.08 19 12V9H17Z" />
    <path d="M10 13.41L5.29004 8.71004L6.71004 7.29004L10 10.59L17.29 3.29004L18.71 4.71004L10 13.41Z" />
  </IconBase>
);
